import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ApiCall } from '../CommonComponents/CustomHooks';
import Loader from '../CommonComponents/Loader';
const ErrorStatus = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const myParam = queryParams.get('Token');
    const paymentID = queryParams.get('OnlinePaymentID');
    const [pageDisplay, setPageDisplay] = useState(false)
    const [subLoading, setSubLoading] = useState(false)
    const [PayBy, setPayBy] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const Validate = async () => {
        await (setSubLoading(true))
        let data = await ApiCall('/api/SalesEntryAPI/CheckPageStatus', { Token: myParam, OnlinePaymentID: paymentID })
        await (setSubLoading(false))
        if (data.status === 'SUCCESS') {
            console.log(data.payBy, 'paybypayby');
            setPayBy(data.payBy)
            await setPageDisplay(true)
        }
    }
    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };
    const handleNavigate = () => {
        navigate('/Dashboard/DealerDashboard')
    };
    useEffect(() => {
        Validate()
    }, [])


    return (
        <>
            {subLoading && <Loader />}
            {pageDisplay ?
                <section className="py-3">
                    <div className="container">
                        <div className="row pt-5 mt-5">
                            <div className="col-12 text-center">
                                <div className="thankyou-img">
                                    <img
                                        src="./images/fail.png"
                                        className="img-fluid"
                                        style={{ maxWidth: 150 }}
                                        alt='...'
                                    />
                                </div>
                                <div className="thankyou-text mt-3">
                                    <h3 className="text-danger fw-bold">{"Failed"}</h3>
                                    <p>
                                        <span className='fs-6'>{"Your payment failed! Please contact your dealer."}</span>
                                    </p>
                                </div>
                                <>
                                    {PayBy === 'DEALER' && (

                                        <div className="col-12 flex-row d-flex flex-wrap justify-content-center gap-3" >
                                            <div className="d-flex flex-column justify-content-center  align-items-center px-4 finalBook"

                                                style={{
                                                    backgroundColor: "green", width: "128px", borderRadius: "4px", cursor: "pointer", paddingTop: '10px',
                                                    boxShadow: isFocused && "2px 2px 8px #E05D4D"
                                                }}
                                                onClick={() => {
                                                    handleNavigate(false)
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleNavigate(false)
                                                    }
                                                }}
                                                onFocus={handleFocus}
                                                onBlur={handleBlur}
                                                tabIndex={0}
                                            >
                                                {/* <IoMdAdd style={{ color: "white", fontSize: "23px", marginTop: "8px", fontWeight: "bolder" }} />*/}
                                                <p style={{ color: "white", fontSize: "12px", fontWeight: 'bold' }}> Go To Home</p>
                                            </div>
                                        </div>
                                    )}
                                </>
                            </div>
                        </div>
                    </div>
                </section> : <section className="py-3">
                    <div className="container">
                        <div className="row pt-5">
                            <div className="col-12 mb-5 text-center">
                                <div className="thankyou-img">
                                    <img src="./images/404.jpg" className="img-fluid" alt='' />
                                </div>
                                <div className="thankyou-text mt-5">
                                    <h3 className="main-heading h2">Page not found</h3>
                                    <p className='fs-6'>you are unauthorized for this action <br /> please review the following url and make sure that It is spelled correctly.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>}
        </>
    )
}
export default ErrorStatus;